/***********⬇️⬇️⬇️⬇️⬇️⬇️⬇️   utils of overall  ⬇️⬇️⬇️⬇️⬇️⬇️⬇️ **********/

import { produce } from 'immer';
import { quesModel_FLAT } from '@model/questionmaires';

export const formatComplexityData = (originData = {}) => {
  const result = {};
  if (originData && originData.overallComplexity) {
    result.overall = getComplexityText(originData.overallComplexity);

    return formatSectionsData(originData?.sectionComplexity, result);
  }

  return result;
};

const formatSectionsData = (originData = [], initailResult, section, type) => {
  originData.forEach(
    (
      {
        name,
        subSectionName,
        questionComplexity = [],
        subSectionComplexity = [],
        ...rest
      },
      index,
    ) => {
      const key = name
        ? name.toLowerCase()
        : `${section}-${subSectionName || 1 + index}`;
      if (type === 'question') {
        return (
          !initailResult[section].questionComplexity &&
          (initailResult[section].questionComplexity =
            getQuestionTexts(originData))
        );
      }

      initailResult[key] = getComplexityText(rest);

      if (subSectionComplexity.length > 0) {
        formatSectionsData(subSectionComplexity, initailResult, key);
      } else if (questionComplexity.length > 0) {
        formatSectionsData(questionComplexity, initailResult, key, 'question');
      }
    },
  );

  return initailResult;
};

const getQuestionTexts = (questions = []) =>
  questions.map(({ optionText: complexityText, ...rest }) => {
    if (rest.questionNum === 1) {
      return getComplexityTextByOption({ ...rest, complexityText });
    }

    return getComplexityText({ ...rest, complexityText });
  });

const getComplexityText = ({ level, complexityText, ...rest } = {}) => {
  //the complexitytext of subsection is String
  if (typeof complexityText === 'string') {
    return { text: ParseJson(complexityText), ...rest, level };
  }

  const result = complexityText?.find((c) => c.level === level) || {};

  const { text, ...restResult } = result;

  if (!isNaN(Number(rest.questionNum))) {
    restResult.subTitle = quesModel_FLAT[rest.questionNum - 1].subTitle;
  }
  return { ...rest, ...restResult, level, text: ParseJson(text) };
};

const getComplexityTextByOption = ({
  questionNum,
  level,
  answer,
  complexityText = [],
  ...rest
}) => {
  if (typeof complexityText === 'string') {
    complexityText = JSON.parse(complexityText);
  }
  let result = {};
  if (questionNum === 1) {
    const currentCriteria =
      quesModel_FLAT[0].options?.[Number(answer.choice) - 1]?.text;

    result = complexityText.find((c) => c.criteria === currentCriteria) || {};
  }

  const { text, ...restResult } = result;

  return {
    ...rest,
    ...restResult,
    level,
    questionNum,
    subTitle: quesModel_FLAT[questionNum - 1].subTitle,
    text: ParseJson(text),
  };
};

export const getOverallPostbody = (stockData, formData) => {
  const result = produce(stockData, (draft) => {
    draft.overallComplexity.complexityText = formData.overall.text || null;

    updateSectionComplexityTextInOverall(draft.sectionComplexity, formData);
  });

  result.sectionComplexity = result.sectionComplexity.map(
    ({ sectionNum, complexityText, subSectionComplexity }) => ({
      sectionNum,
      complexityText: complexityText || null,
      questionComplexity: subSectionComplexity.reduce(
        (result, { questionComplexity }) => [...result, ...questionComplexity],
        [],
      ),
    }),
  );
  return result;
};

const updateSectionComplexityTextInOverall = (
  data,
  formData,
  fatherSection,
) => {
  for (const temp of data) {
    const { name, subSectionComplexity = [], subSectionName } = temp;

    const currentSection = subSectionName
      ? `${fatherSection}-${subSectionName}`
      : name.toLowerCase();

    const currentFormData = formData[currentSection];

    if (currentFormData.questionComplexity) {
      updateQuestion(
        temp.questionComplexity,
        currentFormData.questionComplexity,
      );
    } else {
      temp.complexityText = currentFormData.text;
    }

    if (subSectionComplexity.length > 0) {
      updateSectionComplexityTextInOverall(
        subSectionComplexity,
        formData,
        currentSection,
      );
    }
  }
};

const updateQuestion = (target = [], questionData = []) => {
  for (const index in target) {
    if (Object.hasOwnProperty.call(target, index)) {
      updateOptionText(target[index], questionData[index]);
    }
  }
};

const updateOptionText = (target, data) => {
  for (const temp of target.optionText) {
    if (temp.criteria === data.criteria) {
      temp.text = data.text;
      break;
    }
  }
};

export const enhancePostBodyForManual = (originData, sectionLevelList) => {
  const { overallComplexity, sectionComplexity } = originData;
  const getSectionLevels = (sections, father) =>
    sections.map((s) => {
      const { name, subSectionName, sectionNum, level, subSectionComplexity } =
        s;

      const currentKey = father
        ? `${father}-${name?.toLowerCase?.() || subSectionName}`
        : name?.toLowerCase?.() || subSectionName;

      const result = { level: sectionLevelList[currentKey] || level };

      if (sectionNum) {
        result.sectionNum = s.sectionNum;
      }

      if (subSectionComplexity) {
        result.subSectionLevelList = getSectionLevels(
          subSectionComplexity,
          currentKey,
        );
      }

      return result;
    });

  return {
    sectionLevelList: getSectionLevels(sectionComplexity),
    overallLevel: sectionLevelList.overall || overallComplexity.level,
  };
};

export const ParseJson = (text) => {
  try {
    return JSON.parse(text);
  } catch (error) {
    return text;
  }
};
